import { __awaiter } from "tslib";
import { getRootDomain } from '@lusha-parser/core';
import { actions } from './reducer';
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    install() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            dispatch(this.installLazy());
        });
    }
    installLazy() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () { });
    }
    setPage(url) {
        return (dispatch, getState) => {
            if (!url)
                return null;
            dispatch(actions.setUrl(url));
            const { settings } = getState();
            if (settings.platform === 'scout') {
                dispatch(actions.setParserResult({
                    url,
                    domain: getRootDomain(url),
                }));
            }
        };
    }
}
const AppDispatcher = new Dispatcher();
export default AppDispatcher;
